import * as React from 'react';

type Unselectable = 'on' | 'off' | boolean;

interface Attrs {
  // there's a mismatch between what `helmet.bodyAttributes.toComponent()`
  // & `helmet.htmlAttributes.toComponent()` return and what `<html />` & `<body />`
  // expect as the `unselectable` attribute
  unselectable?: Unselectable;
}

const normalizeUnselectable = (val?: Unselectable) => {
  if (typeof val === 'boolean') {
    if (val) {
      return 'on';
    }

    return 'off';
  }

  return val;
};

const normalizeHTMLprops = (
  attrs: Attrs,
): React.HTMLAttributes<HTMLElement> => ({
  ...attrs,
  unselectable: normalizeUnselectable(attrs.unselectable),
});

export default normalizeHTMLprops;
